// Add your custom JS here.
// Navigation click to section.
jQuery(document).ready(function ($) {


    jQuery('.nav-link[href*="#"]').on("click", function (
        event
    ) {

        // スクロールの速度
        var speed = 400; // ミリ秒
        // アンカーの値取得
        var href = $(this).attr("href");
        // 移動先を取得
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を数値で取得
        var position = target.offset().top;
        // スムーススクロール
        $('body,html').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });


});